var _path, _ellipse;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 15,
    viewBox: "0 0 13 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.936523 6.38621C0.946504 3.44872 3.3359 1.0755 6.27339 1.08548C9.21088 1.09546 11.5841 3.48486 11.5741 6.42235V6.48258C11.538 8.39205 10.4718 10.1569 9.16469 11.5363C8.41716 12.3126 7.58237 12.9998 6.67697 13.5843C6.43487 13.7938 6.07577 13.7938 5.83367 13.5843C4.48393 12.7058 3.29931 11.5966 2.33399 10.3075C1.47361 9.18342 0.985127 7.81903 0.936523 6.40428L0.936523 6.38621Z",
    stroke: "#505F79",
    strokeWidth: 1.1875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 6.25545,
    cy: 6.48836,
    rx: 1.70466,
    ry: 1.70466,
    stroke: "#505F79",
    strokeWidth: 1.1875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.e7c96ee43d5eda8bbb8e33f5910ce84a.svg";
export { ForwardRef as ReactComponent };